import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Center, Spinner, Text, VStack } from '@chakra-ui/react';

export default function EndRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get('userId');

  useEffect(() => {
    if (!userId) {
      navigate('/play');
      return;
    }

    // Redirect to reveal page after a short delay
    const timer = setTimeout(() => {
      navigate(`/reveal/${userId}`);
    }, 2000);

    return () => clearTimeout(timer);
  }, [userId, navigate]);

  return (
    <Center h="100vh">
      <VStack spacing={4}>
        <Spinner size="xl" color="purple.400" />
        <Text fontSize="lg" color="gray.600">
          Preparing your soul mirror...
        </Text>
      </VStack>
    </Center>
  );
} 